
//
// Box Selector
//
// Simple visual proxy for radio selection
//

module.exports = function BoxSelectorWidget ($host, config, $$) {

  var input = $host[0];

  function setValue (value) {
    return input.value = value;
  }

  return {
    name:     input.name,
    setValue: setValue
  }

}

